module.exports = __webpack_public_path__ + "static/img/border-1.9dc7086d.png";